import { createGlobalStyle } from "styled-components";
import reset from "styled-reset";

const GlobalStyle = createGlobalStyle`
    ${reset};

    $test: 1;

    @font-face {
      font: {
         family: 'Noto Sans KR';
         style: normal;
         weight: 100;
      }
      src: url("assets/fonts/NotoSansKR-Thin.otf") format('truetype')
    }
    @font-face {
      font: {
         family: 'Noto Sans KR';
         style: normal;
         weight: 200;
      }
      src: url("assets/fonts/NotoSansKR-Light.otf") format('truetype')
    }
    @font-face {
      font: {
         family: 'Noto Sans KR';
         style: normal;
         weight: 400;
      }
      src: url("assets/fonts/NotoSansKR-Regular.otf") format('truetype')
    }
    @font-face {
      font: {
         family: 'Noto Sans KR';
         style: normal;
         weight: 600;
      }
      src: url("assets/fonts/NotoSansKR-Medium.otf") format('truetype')
    }
    @font-face {
      font: {
         family: 'Noto Sans KR';
         style: normal;
         weight: 700;
      }
      src: url("assets/fonts/NotoSansKR-Bold.otf") format('truetype')
    }
    @font-face {
      font: {
         family: 'Noto Sans KR';
         style: normal;
         weight: 900;
      }
      src: url("assets/fonts/NotoSansKR-Black.otf") format('truetype')
    }

    @font-face {
      font: {
         family: 'Noto Sans';
         style: normal;
         weight: 100;
      }
      src: url("assets/fonts/NotoSans-Thin.otf") format('truetype')
    }
    @font-face {
      font: {
         family: 'Noto Sans';
         style: normal;
         weight: 200;
      }
      src: url("assets/fonts/NotoSans-ExtraLight.otf") format('truetype')
    }
    @font-face {
      font: {
         family: 'Noto Sans';
         style: normal;
         weight: 300;
      }
      src: url("assets/fonts/NotoSans-Light.otf") format('truetype')
    }
    @font-face {
      font: {
         family: 'Noto Sans';
         style: normal;
         weight: 400;
      }
      src: url("assets/fonts/NotoSans-Regular.otf") format('truetype')
    }
    @font-face {
      font: {
         family: 'Noto Sans';
         style: normal;
         weight: 500;
      }
      src: url("assets/fonts/NotoSans-Medium.otf") format('truetype')
    }
    @font-face {
      font: {
         family: 'Noto Sans';
         style: normal;
         weight: 600;
      }
      src: url("assets/fonts/NotoSans-SemiBold.otf") format('truetype')
    }
    @font-face {
      font: {
         family: 'Noto Sans';
         style: normal;
         weight: 700;
      }
      src: url("assets/fonts/NotoSans-Bold.otf") format('truetype')
    }
    @font-face {
      font: {
         family: 'Noto Sans';
         style: normal;
         weight: 800;
      }
      src: url("assets/fonts/NotoSans-ExtraBold.otf") format('truetype')
    }
    @font-face {
      font: {
         family: 'Noto Sans';
         style: normal;
         weight: 900;
      }
      src: url("assets/fonts/NotoSans-Black.otf") format('truetype')
    }

    a{
      text-decoration: none;
      color: inherit;
    }
    *{
      font-family: "Noto Sans KR", "Noto Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif !important;
    }
    html, body{
      margin: 0;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      font-size: 16px;
      background-color: #fff;
    }
    input, textarea{
      color: #fff;
      font-size: 61px;
    }

    code {
      color: #fff;
      font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;
    }
    .filepond--root{
      margin-bottom: 0px !important;
    }
    .filepond--credits{
      display: none;
    }
    .filepond--panel-root{
      background-color: transparent !important;
    }
    .filepond--action-remove-item{
      display: none;
    }
`;

export default GlobalStyle;
